import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import '../css/elements/logo.css';
const Logo = () => (
  <Link to="/" className="logo">
    <LogoImage src="assets/Logo-iBAN.svg" alt="iBAN logo" />
  </Link>
);
export default Logo;

const LogoImage = styled.img`
  height: 75%;
`;



// WEBPACK FOOTER //
// ./src/elements/Logo.js